/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

import AccountReservations, { accountReservationsPropTypes } from '../../../../../ui-kitchen/src/components/Account/AccountReservations/AccountReservations';
import AutocompleteContainer, { autocompleteContainerPropTypes } from '../../containers/AutocompleteContainer/AutocompleteContainer';
import AlgorithmicLists, { algorithmicListsPropTypes } from '../../../../../ui-kitchen/src/components/AlgorithmicLists/AlgorithmicLists';
import RatingForm, { ratingFormPropTypes } from '../RatingForm/RatingForm';
import Download, { downloadPropTypes } from '../Download/Download';
import EventsByLocation, { eventsByLocationPropsTypes } from '../EventsByLocation/EventsByLocation';
import EventDetailsContainer, { eventDetailsContainerPropTypes } from '../../../../../ui-kitchen/src/containers/EventDetailsContainer/EventDetailsContainer';
import Footer, { footerPropTypes } from '../Footer/Footer';
import Header, { headerPropTypes } from '../Header/Header';
import ListVenues, { listVenuesPropTypes } from '../ListVenues/ListVenues';
import LocationsContainer, { locationsContainerPropTypes } from '../../containers/LocationsContainer/LocationsContainer';
import MenuContainer, { menuContainerPropTypes } from '../../containers/MenuContainer/MenuContainer';
import ModalsContainer, { modalsContainerPropTypes } from '../../containers/ModalsContainer/ModalsContainer';
import Notify, { notifyPropTypes } from '../../../../../ui-kitchen/src/components/Notify/Notify';
import NotifyVenueGroupModal, { NotifyVenueGroupModalPropTypes } from '../../../../../ui-kitchen/src/components/NotifyVenueGroupModal/NotifyVenueGroupModal';
import NotifyChefsListModal, { NotifyChefsListModalPropTypes } from '../../../../../ui-kitchen/src/components/NotifyChefsListModal/NotifyChefsListModal';
import OptOut, { optOutPropTypes } from '../OptOut/OptOut';
import PasswordReset, { passwordResetPropTypes } from '../../../../../ui-kitchen/src/components/Form/PasswordResetForm';
import PersonalizedList, { personalizedListPropTypes } from '../List/PersonalizedList';
import PrepayConfirmation, { prepayConfirmationPropTypes } from '../Prepay/PrepayConfirmation';
import PrepayPayment, { prepayPaymentPropTypes } from '../Prepay/PrepayPayment';
import PrepayStart, { prepayStartPropTypes } from '../Prepay/PrepayStart';
import ResyCalendar, { resyCalendarPropTypes } from '../../../../../ui-kitchen/src/components/ResyCalendar/ResyCalendar';
import ResySpotlight, { resySpotlightPropTypes } from '../ResySpotlight/ResySpotlight';
import RGAListContainer, { rgaListContainerPropTypes } from '../../containers/RGAListContainer/RGAListContainer';
import HomepageCollectionsNav, { homepageCollectionsNavPropTypes } from '../../containers/HomepageCollectionsNav/HomepageCollectionsNav';
import RSVP, { rsvpPropTypes } from '../RSVP/RSVP';
import SearchContainer, { searchContainerPropTypes } from '../../containers/SearchContainer/SearchContainer';
import TopNav, { topNavPropTypes } from '../Nav/TopNav/TopNav';
import VenueListContainer, { venueListContainerPropTypes } from '../../containers/VenueListContainer/VenueListContainer';
import VenuePage, { venuePagePropTypes } from '../VenuePage/VenuePage';
import MultiStepListModal from '../../../../../ui-kitchen/src/components/MultiStepListModal';
import AnalyticsProvider from '../../../../../ui-kitchen/src/components/AnalyticsProvider';
import AmexAdsContainer from '../../containers/AmexAdsContainer/AmexAdsContainer';
import Sidenav, { sidenavPropTypes } from '../../../../../ui-kitchen/src/components/Sidenav/Sidenav';

// Eliminates noise in the browser console for required props
// that are connected via the Redux store in the underlying components
const removeReqdConnectedProps = (types) => {
  const connectedProps = [
    'dispatch', 'configStatus', 'resyLocationsConfigStatus', 'allLocations', 'selectedCoreISODate', 'selectedCoreSeats', 'selectedCoreTime',
    'getAutocompleteSearchThunk', 'getMarketLocationThunk', 'getVenueSearchThunk', 'setSelectedLocationThunk',
  ];
  const newTypes = { ...types };
  connectedProps.forEach((p) => delete newTypes[p]);
  return newTypes;
};

const AccountReservationsProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <AccountReservations {...props} />
    </Provider>
  );
};

AccountReservationsProvider.propTypes = {
  ...removeReqdConnectedProps(accountReservationsPropTypes),
};

const AlgorithmicListsProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <AlgorithmicLists {...props} />
    </Provider>
  );
};

AlgorithmicListsProvider.propTypes = {
  ...algorithmicListsPropTypes,
};

const RatingFormProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <RatingForm {...props} />
    </Provider>
  );
};

RatingFormProvider.propTypes = {
  ...ratingFormPropTypes,
};

const AutocompleteContainerProvider = (props) => {
  const { $rootScope, Analytics } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <AutocompleteContainer {...props} Analytics={Analytics} />
    </Provider>
  );
};

AutocompleteContainerProvider.propTypes = {
  ...removeReqdConnectedProps(autocompleteContainerPropTypes),
};

const DownloadProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <Download {...props} />
    </Provider>
  );
};

DownloadProvider.propTypes = {
  ...downloadPropTypes,
};

const EventDetailsContainerProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <EventDetailsContainer {...props} />
    </Provider>
  );
};

EventDetailsContainerProvider.propTypes = {
  ...eventDetailsContainerPropTypes,
};

const EventsByLocationProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <EventsByLocation {...props} />
    </Provider>
  );
};

EventsByLocationProvider.propTypes = {
  ...eventsByLocationPropsTypes,
};

const FooterProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <Footer {...props} />
    </Provider>
  );
};

FooterProvider.propTypes = {
  ...removeReqdConnectedProps(footerPropTypes),
};

const AmexAdsContainerProvider = ({ $rootScope, Analytics, page }) => (
  <Provider store={$rootScope.reduxStore}>
    <AnalyticsProvider Analytics={Analytics}>
      <AmexAdsContainer page={page || 'home_page'} />
    </AnalyticsProvider>
  </Provider>
);

AmexAdsContainerProvider.propTypes = {
  $rootScope: PropTypes.shape({
    reduxStore: PropTypes.object.isRequired,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }),
  page: PropTypes.string,
};

AmexAdsContainerProvider.defaultProps = {
  Analytics: undefined,
  page: undefined,
};

const HeaderProvider = (props) => {
  const { $rootScope, Analytics } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <AnalyticsProvider Analytics={Analytics}>
        <Header {...props} />
      </AnalyticsProvider>
      <MultiStepListModal Analytics={Analytics} />
    </Provider>
  );
};

HeaderProvider.propTypes = {
  ...headerPropTypes,
};

const ListVenuesProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <ListVenues {...props} />
    </Provider>
  );
};

ListVenuesProvider.propTypes = {
  ...listVenuesPropTypes,
};

const LocationsContainerProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <LocationsContainer {...props} />
    </Provider>
  );
};

LocationsContainerProvider.propTypes = {
  ...locationsContainerPropTypes,
};

const MenuContainerProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <MenuContainer {...props} />
    </Provider>
  );
};

MenuContainerProvider.propTypes = {
  ...removeReqdConnectedProps(menuContainerPropTypes),
};

const ModalsContainerProvider = (props) => {
  const { $rootScope, Analytics } = props;
  return (
    <AnalyticsProvider Analytics={Analytics}>
      <Provider store={$rootScope.reduxStore}>
        <ModalsContainer {...props} />
      </Provider>
    </AnalyticsProvider>
  );
};

ModalsContainerProvider.propTypes = {
  ...modalsContainerPropTypes,
};

const NotifyProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <Notify {...props} />
    </Provider>
  );
};

NotifyProvider.propTypes = {
  ...notifyPropTypes,
};

const NotifyVenueGroupModalProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <NotifyVenueGroupModal {...props} />
    </Provider>
  );
};

NotifyVenueGroupModalProvider.propTypes = {
  ...NotifyVenueGroupModalPropTypes,
};

const NotifyChefsListModalProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <NotifyChefsListModal {...props} />
    </Provider>
  );
};

NotifyChefsListModalProvider.propTypes = {
  ...NotifyChefsListModalPropTypes,
};

const OptOutProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <OptOut {...props} />
    </Provider>
  );
};

OptOutProvider.propTypes = {
  ...optOutPropTypes,
};

const PasswordResetProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <PasswordReset {...props} />
    </Provider>
  );
};

PasswordResetProvider.propTypes = {
  ...passwordResetPropTypes,
};

const PersonalizedListProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <PersonalizedList {...props} />
    </Provider>
  );
};

PersonalizedListProvider.propTypes = {
  ...personalizedListPropTypes,
};

const PrepayConfirmationProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <PrepayConfirmation {...props} />
    </Provider>
  );
};

PrepayConfirmationProvider.propTypes = {
  ...prepayConfirmationPropTypes,
};

const PrepayPaymentProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <PrepayPayment {...props} />
    </Provider>
  );
};

PrepayPaymentProvider.propTypes = {
  ...removeReqdConnectedProps(prepayPaymentPropTypes),
};

const PrepayStartProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <PrepayStart {...props} />
    </Provider>
  );
};

PrepayStartProvider.propTypes = {
  ...prepayStartPropTypes,
};

const ResyCalendarProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <ResyCalendar {...props} />
    </Provider>
  );
};
ResyCalendarProvider.propTypes = {
  ...resyCalendarPropTypes,
};

const ResySpotlightProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <ResySpotlight {...props} />
    </Provider>
  );
};

ResySpotlightProvider.propTypes = {
  ...resySpotlightPropTypes,
};

const HomepageCollectionsNavProvider = (props) => {
  const { $rootScope, Analytics } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <HomepageCollectionsNav {...props} Analytics={Analytics} />
    </Provider>
  );
};

HomepageCollectionsNavProvider.propTypes = {
  ...homepageCollectionsNavPropTypes,
};

const RGAListContainerProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <RGAListContainer {...props} />
    </Provider>
  );
};
RGAListContainerProvider.propTypes = {
  ...removeReqdConnectedProps(rgaListContainerPropTypes),
};

const RSVPProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <RSVP {...props} />
    </Provider>
  );
};
RSVPProvider.propTypes = {
  ...rsvpPropTypes,
};

const SearchContainerProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <SearchContainer {...props} />
    </Provider>
  );
};

SearchContainerProvider.propTypes = {
  ...removeReqdConnectedProps(searchContainerPropTypes),
};

const SidenavProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <Sidenav {...props} />
    </Provider>
  );
};

SidenavProvider.propTypes = {
  ...removeReqdConnectedProps(sidenavPropTypes),
};

const TopNavProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <TopNav {...props} />
    </Provider>
  );
};

TopNavProvider.propTypes = {
  ...removeReqdConnectedProps(topNavPropTypes),
};

const VenueListContainerProvider = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <VenueListContainer {...props} />
    </Provider>
  );
};

VenueListContainerProvider.propTypes = {
  ...removeReqdConnectedProps(venueListContainerPropTypes),
};
const VenuePageProvider = (props) => {
  const { $rootScope, Analytics } = props;
  return (
    <AnalyticsProvider Analytics={Analytics}>
      <Provider store={$rootScope.reduxStore}>
        <VenuePage {...props} />
      </Provider>
    </AnalyticsProvider>
  );
};

VenuePageProvider.propTypes = {
  ...venuePagePropTypes,
};

export {
  AccountReservationsProvider,
  AutocompleteContainerProvider,
  AlgorithmicListsProvider,
  DownloadProvider,
  EventDetailsContainerProvider,
  EventsByLocationProvider,
  FooterProvider,
  AmexAdsContainerProvider,
  HeaderProvider,
  ListVenuesProvider,
  LocationsContainerProvider,
  MenuContainerProvider,
  ModalsContainerProvider,
  NotifyProvider,
  NotifyVenueGroupModalProvider,
  NotifyChefsListModalProvider,
  OptOutProvider,
  PasswordResetProvider,
  PersonalizedListProvider,
  PrepayConfirmationProvider,
  PrepayPaymentProvider,
  PrepayStartProvider,
  RatingFormProvider,
  ResyCalendarProvider,
  ResySpotlightProvider,
  HomepageCollectionsNavProvider,
  RGAListContainerProvider,
  RSVPProvider,
  SearchContainerProvider,
  SidenavProvider,
  TopNavProvider,
  VenueListContainerProvider,
  VenuePageProvider,
};
